<template>
  <div>
    <BaseFilter title="EXPERTISE" :state="tags">
      <template #default="{ data }">
        <Select
          id="input-tags"
          :selectProps="{
            label: 'tag',
            options: data,
            selectable: option => !option.disabled,
            value,
            disabled: false,
            multiple: true,
            reduce: it => it.id
          }"
          :onInput="onInput"
          data-testid="select-tags"
        >
          <template #selected-option="{ option }">
            {{ option.tag }}
          </template>
          <template #option="{ option }">
            {{ option.tag }}
          </template>
          <template #no-options>
            No options
          </template>
        </Select>
      </template>
    </BaseFilter>
  </div>
</template>

<script>
import localAsyncAction from '@/mixins/localAsyncAction'
import apiModules from '@/services'
import BaseFilter from '@/components/BaseFilter/BaseFilter'
import Select from '@/components/Select/Select'

export default {
  name: 'TagsFilter',
  components: {
    BaseFilter,
    Select
  },
  mixins: [
    localAsyncAction({
      key: 'tags',
      initialState: [],
      fetcher: {
        methodName: 'fetchTags',
        handler: apiModules.fetchTags
      }
    })
  ],
  props: {
    value: {
      type: [Number, Array],
      default: null
    },
    filters: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    filters: {
      handler(filters) {
        this.fetchTags(filters)
      },
      deep: true
    }
  },
  created() {
    this.fetchTags(this.filters)
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>
